
import {
  ALL_FILES,
  ALL_FILES_SUCCESS,
  ERROR_MSG,
  SIGNED_URL_FOR_UPLOAD,
  SIGNED_URL_FOR_UPLOAD_SUCCESS,
  SIGNED_URL_FOR_DOWNLOAD,
  SIGNED_URL_FOR_DOWNLOAD_SUCCESS,
  GET_USER_DETAILS,
  GET_USER_DETAILS_SUCCESS,
  GET_USER_TASK_DECISION_FLAG,
  GET_USER_TASK_DECISION_FLAG_SUCCESS,
  FILES_UPLOAD_SUCCESS,
  FILES_DOWNLOAD,
  FILES_DOWNLOAD_SUCCESS,
  DROPZONE_CONFIG,
  DROPZONE_CONFIG_SUCCESS,
  DOWNLOADING,
  DOWNLOADING_SUCCESS,
  NOTIFY,
  NOTIFY_SUCCESS,
  META_NOTIFY,
  META_NOTIFY_SUCCESS
} from './mutation-types'

export const productMutations = {
  [ALL_FILES] (state) {
    state.showLoader = true
  },
  [ALL_FILES_SUCCESS] (state, payload) {
    state.showLoader = false
    state.files = payload
  },
  [ERROR_MSG] (state, payload) {
    state.showLoader = false
  },
  [SIGNED_URL_FOR_UPLOAD]: function (state, payload) {
    state.showLoader = true
  },
  [SIGNED_URL_FOR_UPLOAD_SUCCESS] (state, payload) {
    state.showLoader = false
    state.signedurls = payload
  },
  [SIGNED_URL_FOR_DOWNLOAD]: function (state, payload) {
    state.showLoader = true
  },
  [SIGNED_URL_FOR_DOWNLOAD_SUCCESS] (state, payload) {
    state.signedurls = payload
  },
  [GET_USER_DETAILS]: function (state, payload) {
    state.showLoader = true
  },
  [GET_USER_DETAILS_SUCCESS] (state, payload) {
    state.showLoader = false
    state.userid = payload
  },
  [GET_USER_TASK_DECISION_FLAG]: function (state) {
    state.showLoader = true
  },
  [GET_USER_TASK_DECISION_FLAG_SUCCESS] (state, payload) {
    state.showLoader = false
    state.usertaskdecision = payload
  },
  [FILES_UPLOAD_SUCCESS] (state, payload) {},
  [FILES_DOWNLOAD] (state, payload) {
    state.showLoaded = true
  },
  [FILES_DOWNLOAD_SUCCESS] (state, payload) {
    state.showLoaded = false
  },
  [DROPZONE_CONFIG] (state) {
    state.showLoader = true
  },
  [DROPZONE_CONFIG_SUCCESS] (state, payload) {
    state.showLoader = false
    state.dropzonedata = payload
  },
  [DOWNLOADING] (state) {
    state.showLoader = true
  },
  [DOWNLOADING_SUCCESS] (state) {
    state.showLoader = false
  },
  [NOTIFY] (state) {
    state.showLoader = true
  },
  [NOTIFY_SUCCESS] (state) {
    state.showLoader = false
  },
  [META_NOTIFY] (state) {
    state.showLoader = true
  },
  [META_NOTIFY_SUCCESS] (state) {
    state.showLoader = false
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js